<template>
  <div class="application" onselectstart="return false;" unselectable="on" @contextmenu.prevent>
    <el-row>
      <el-col :span="8">
        <el-card :body-style="{ padding: '0px' }" shadow="hover">
          <img src="../../../../static/pw.jpg" class="image" />
          <div style="padding: 14px;">
            <span class="fontTxet">票务系统</span>
            <div class="bottom clearfix">
              <time class="time">待开发</time>
            </div>
          </div>
        </el-card>
      </el-col>
      <a href="/egs.html">
        <el-col :span="8">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <img src="../../../../static/mj.jpg" class="image" />
            <div style="padding: 14px;">
              <span class="fontTxet">门禁系统</span>
              <div class="bottom clearfix">
                <time class="time">待开发</time>
              </div>
            </div>
          </el-card>
        </el-col>
      </a>
      <el-col :span="8">
        <el-card :body-style="{ padding: '0px' }" shadow="hover">
          <img src="../../../../static/cy.jpg" class="image" />
          <div style="padding: 14px;">
            <span class="fontTxet">餐饮系统</span>
            <div class="bottom clearfix">
              <time class="time">待开发</time>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "application",
  data() {
    return {
      currentDate: new Date(),
      article: {
        title: "",
        tag: "",
        top: false,
        content: {}
      },
      restaurants: []
    };
  },
  methods: {
    hrefto() {
      this.$router.push({ path: "/index" });
    }
  }
};
</script>

<style scoped>
.fontTxet {
  font-size: 23px;
}

.el-col-8 {
  width: 15%;
  margin-left: 3.5%;
}

.time {
  font-size: 13px;
  color: red;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/system/index/application/application.vue